import { CoreDomainSearchModule } from '@wix/core-domain-search';
import { useEffect } from 'react';
import { DomainSearchGateModule } from '../domainSearchGate.module';
import { TOP_TLDS_COUNT } from './tldOfferWidget.constants';
import { useTldOffersData } from './useTldOffersData';
let lastReportedDomain;
export const resetTldStripEligibilityReports = () => {
  lastReportedDomain = undefined;
};
export const useTldStripEligibility = _ref => {
  var _CoreDomainSearchModu;
  let domain = _ref.domain,
    componentName = _ref.componentName,
    enabled = _ref.enabled;
  const searchTerm = (_CoreDomainSearchModu = CoreDomainSearchModule.SDK.domainInputStore.useSubmittedFilters()) == null ? void 0 : _CoreDomainSearchModu.query;
  const _useTldOffersData = useTldOffersData(enabled ? domain : '', {
      withPrices: false
    }),
    sld = _useTldOffersData.sld,
    offers = _useTldOffersData.offers,
    isLoading = _useTldOffersData.isLoading,
    isEligible = _useTldOffersData.isEligible,
    isFolded = _useTldOffersData.isFolded;
  const tlds = isFolded ? '' : offers.slice(0, TOP_TLDS_COUNT).join(',');
  useEffect(() => {
    if (!enabled || !searchTerm || isLoading || !isEligible || !sld || lastReportedDomain === domain) {
      return;
    }
    lastReportedDomain = domain;
    DomainSearchGateModule.internals.bi.onTldStripViewed == null || DomainSearchGateModule.internals.bi.onTldStripViewed({
      componentName,
      sld,
      pageNumber: 0,
      tlds
    });
  }, [enabled, searchTerm, isLoading, isEligible, sld, domain, componentName, tlds]);
};
//# sourceMappingURL=useTldStripEligibility.js.map